import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import LinkModal from '@/components/LinkModal.vue';
import VueMarkdown from 'vue-markdown';
let RollTable = class RollTable extends Vue {
};
__decorate([
    Prop(Array)
], RollTable.prototype, "items", void 0);
__decorate([
    Prop(String)
], RollTable.prototype, "title", void 0);
__decorate([
    Prop(Boolean)
], RollTable.prototype, "isLeftAlign", void 0);
RollTable = __decorate([
    Component({
        components: {
            LinkModal,
            VueMarkdown
        }
    })
], RollTable);
export default RollTable;
